import { escapeAttr, escapeHtml } from '../pasteUtils/htmlEscape';
import { evaluateDocMath } from '../../../../utils/mathExpr';

export const MATH_PILL_SELECTOR = '[data-doc-math]';

/** Fresh math pill — same look as a variable pill (`.doc-variable`). */
export const buildMathHtml = (expr, { trailingSpace = false } = {}) => {
  const formula = String(expr ?? '').trim();
  return (
    `<span class="doc-variable" data-doc-math data-math-expr="${escapeAttr(formula)}" ` +
    `data-var-state="unresolved" contenteditable="false" spellcheck="false">${escapeHtml(formula || 'math')}</span>` +
    (trailingSpace ? '&nbsp;' : '\u200B')
  );
};

const applyMathDisplay = (tag, resolveVariable) => {
  const expr = tag.getAttribute('data-math-expr') || '';
  const { state, text, color, tip } = evaluateDocMath(expr, resolveVariable);
  let changed = false;

  if (tag.getAttribute('data-var-state') !== state) {
    tag.setAttribute('data-var-state', state);
    changed = true;
  }
  if (tag.textContent !== text) {
    tag.textContent = text;
    changed = true;
  }
  const style = color ? `--var-color: ${color};` : null;
  if ((tag.getAttribute('style') || null) !== style) {
    if (style) tag.setAttribute('style', style);
    else tag.removeAttribute('style');
    changed = true;
  }
  if ((tag.getAttribute('data-var-tip') || '') !== tip) {
    tag.setAttribute('data-var-tip', tip);
    changed = true;
  }
  if (tag.hasAttribute('title')) {
    tag.removeAttribute('title');
    changed = true;
  }
  if (tag.getAttribute('spellcheck') !== 'false') {
    tag.setAttribute('spellcheck', 'false');
    changed = true;
  }
  return changed;
};

/** Refresh every math pill in HTML. Returns original string if unchanged. */
export const refreshMathHtml = (html, resolveVariable) => {
  if (!html || !html.includes('data-doc-math')) return html;
  const host = document.createElement('div');
  host.innerHTML = html;
  let changed = false;
  host.querySelectorAll('[data-doc-math]').forEach((tag) => {
    if (applyMathDisplay(tag, resolveVariable)) changed = true;
  });
  return changed ? host.innerHTML : html;
};
